import { InputPadrao, InputDatePicker } from '../../../../components/Inputs'
import { InputEstado, InputEstadoCivil, InputGrauInstrucao, InputMunicipio, InputPais, InputRaca, InputSexo } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect } from 'react'
import Yup, { validaCPF, validaData } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, get } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'

const CadastroPaciente = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})

    const [validacao] = useState(Yup.object({
        nome: Yup.string().required().nullable().trim(),
        nome_mae: Yup.string().required().nullable().trim(),
        inscricao_inss: Yup.string().required().nullable().trim(),
        cpf: Yup.string().test('CPF', 'CPF inválido!', function (value) { return validaCPF(this.parent.cpf) })
            .nullable()
            .max(100).required(),
        naturalidade: Yup.string().nullable().required(),
        sexo: Yup.string().nullable().required(),
        raca: Yup.string().nullable().required(),
        grau_instrucao: Yup.string().nullable().required(),
        rg: Yup.string().nullable().required(),
        estado_civil: Yup.string().nullable().required(),
        data_nascimento: Yup.string().nullable().max(200).trim()
            .test('Data Nascimento', 'Data inválida!', function (value) { return validaData(this.parent.data_nascimento) }),
        data_admissao: Yup.string().nullable().max(200).trim()
            .test('Data Admissão', 'Data inválida!', function (value) { return validaData(this.parent.data_admissao) }),
        data_expedicao: Yup.string().nullable().max(200).trim()
            .test('Data Expedição', 'Data inválida!', function (value) { return validaData(this.parent.data_expedicao) }),

    }))
    const manter = []

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        salvar(
            { ...values },
            '/faturamento/cooperadopf',
            obj => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    propsFormik.resetForm({})
                    manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSalvando(false)
                }
                else {
                    props.history.push('/faturamento/cooperadopf/consulta')
                }
            },
            () => setSalvando(false))
    }

    useEffect(_ => {
        if (id)
            Promise.resolve(get(`/faturamento/cooperadopf/${id}`)).then(obj => {
                if (id && !obj.id)
                    props.history.push('/faturamento/cooperadopf/consulta')
                setValoresIniciais(obj)
            })
        else {
            setValoresIniciais({
                nome: '',
                cpf: ''
            })
        }
    }, [id])

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => {
                return (<Form>
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='row'>
                                <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' />

                                <InputPadrao label='Nome' name='nome' type='text' placeholder='Nome' obrigatorio={true}
                                    tamanho={'col-sm-12 col-lg-6 col-xl-6'} autoFocus salvarENovo={salvarENovo} />

                                <InputPadrao label='CNES' name='cnes' type='text' placeholder='CNES'
                                    tamanho={'col-sm-12 col-lg-6 col-xl-3'} autoFocus salvarENovo={salvarENovo} />

                                <InputDatePicker tamanho={"col-sm-12 col-lg-6 col-md-7 col-xl-3"} label="Data de Nascimento" name="data_nascimento" type="text"
                                    setarValor={value => {
                                        propsFormik.setFieldValue("data_nascimento", value)
                                    }} />

                                <InputSexo label='Sexo' name='sexo' placeholder='Sexo' propsFormik={propsFormik} tamanho='col-sm-12 col-lg-6 col-xl-3' obrigatorio={true} />

                                <InputRaca label='Raça' name='raca' placeholder='Raça' propsFormik={propsFormik} tamanho='col-sm-12 col-lg-6 col-xl-3' obrigatorio={true} />

                                <InputGrauInstrucao label='Grau Instrução' name='grau_instrucao' placeholder='Grau Instrução' propsFormik={propsFormik} tamanho='col-sm-12 col-lg-6 col-xl-3' obrigatorio={true} />

                                <InputPadrao mascara="1111" tamanho={"col-sm-12 col-lg-4 col-xl-3"}
                                    label="Ano de Formatura" name="ano_formatura" type="text" placeholder="Ano de Formatura" />

                                <InputPadrao mascara="111.111.111-11" tamanho={"col-sm-12 col-lg-4 col-xl-3"}
                                    label="CPF" name="cpf" type="text" placeholder="CPF" />

                                <InputPadrao label='RG' name='rg' type='text' placeholder='RG'
                                    tamanho={'col-sm-12 col-lg-3 col-md-6 col-xl-3'} obrigatorio={true} />

                                <InputPadrao label='Órgão Expedidor' name='orgao_expedidor' type='text' placeholder='Órgão Expedidor'
                                    tamanho={'col-sm-12 col-lg-6 col-xl-3'} autoFocus salvarENovo={salvarENovo} />

                                <InputEstado label='UF Órgão Expedidor' name='uf_orgao_expedidor' placeholder='UF Órgão Expedidor' propsFormik={propsFormik} tamanho='col-sm-12 col-lg-6 col-xl-3' />

                                <InputDatePicker tamanho={"col-sm-12 col-lg-6 col-md-7 col-xl-3"} label="Data Expedição" name="data_expedicao" type="text"
                                    setarValor={value => {
                                        propsFormik.setFieldValue("data_expedicao", value)
                                    }} />

                                <InputMunicipio
                                    tamanho={"col-lg-3 col-sm-12"}
                                    label='Naturalidade'
                                    name='naturalidade'
                                    placeholder='Naturalidade'
                                    obrigatorio={true}
                                    propsFormik={propsFormik} />

                                <InputEstadoCivil label="Estado Civil" name="estado_civil" placeholder="Estado Civil" propsFormik={propsFormik} tamanho='col-sm-12 col-lg-4 col-xl-3' obrigatorio={true} />

                                <InputPais label='País Nascimento' name='pais_nascimento' placeholder='País Nascimento' propsFormik={propsFormik} tamanho='col-sm-12 col-lg-6 col-xl-3' />

                                <InputPais label='País Nacionalidade' name='pais_nacionalidade' placeholder='País Nacionalidade' propsFormik={propsFormik} tamanho='col-sm-12 col-lg-6 col-xl-3' />

                                <InputPadrao
                                    mascaraTelefone={true}
                                    label="Telefone"
                                    name="telefone"
                                    type="text"
                                    tamanho={"col-sm-12 col-lg-6 col-xl-3"}
                                    placeholder="Telefone" classeTooltip={"tooltip-input-modal"}
                                />

                                <InputPadrao
                                    mascaraTelefone={true}
                                    label="Celular"
                                    name="celular"
                                    type="text"
                                    tamanho={"col-sm-12 col-lg-6 col-xl-3"}
                                    placeholder="Celular" classeTooltip={"tooltip-input-modal"}
                                />

                                <InputPadrao label='Nome Pai' name='nome_pai' type='text' placeholder='Nome Pai'
                                    tamanho={'col-sm-12 col-lg-6 col-xl-6'} autoFocus salvarENovo={salvarENovo} />

                                <InputPadrao label='Nome Mãe' name='nome_mae' type='text' placeholder='Nome Mãe' obrigatorio={true}
                                    tamanho={'col-sm-12 col-lg-6 col-xl-6'} autoFocus salvarENovo={salvarENovo} />

                                <InputPadrao
                                    tamanho={"col-lg-3 col-xl-4 col-sm-12"}
                                    label="E-mail"
                                    name="email"
                                    type="text"
                                    placeholder="E-mail" />

                                <InputPadrao
                                    tamanho={"col-lg-3 col-xl-3 col-sm-12"}
                                    label="Inscrição Municipal"
                                    name="inscricao_municipal"
                                    type="text"
                                    placeholder="Inscrição Municipal" />

                                <InputPadrao
                                    tamanho={"col-lg-3 col-xl-3 col-sm-12"}
                                    label="Inscrição INSS"
                                    name="inscricao_inss"
                                    type="text"
                                    placeholder="Inscrição INSS" obrigatorio={true} />

                                <InputPadrao label='Código na Operadora' name='codigo_operadora' type='text' placeholder='Código na Operadora'
                                    tamanho={'col-sm-12 col-lg-6 col-md-7 col-xl-3'} />

                                <InputDatePicker tamanho={"col-sm-12 col-lg-6 col-md-7 col-xl-3"} label="Data Admissão" name="data_admissao" type="text"
                                    setarValor={value => {
                                        propsFormik.setFieldValue("data_admissao", value)
                                    }} />

                                <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                            </div>
                        </div>
                    </div>
                    <div className='separator mt-40 mb-5'></div>
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                        {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                    </div>
                </Form>)
            }}
        </Formik>
    )
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>faturamento</span>,
        () => <Link className='link-active' to={'/faturamento/cooperadopf/consulta'}>Cooperado PF</Link>,
    ]
    return (<>
        {<HeaderCadastro titulo={"Cadastro Cooperado PF"} link={links} />}
        <CadastroPaciente {...props} />
    </>
    )
}
export { CadastroPaciente }
export default Cadastro